export const ethnicities = [
  "African",
  "Caribbean",
  "Indian",
  "Melanesian",
  "Australasian/Aboriginal",
  "Chinese",
  "Guamanian",
  "Japanese",
  "Korean",
  "Polynesian",
  "European/Anglo Saxon",
  "Latin American",
  "Arabic",
  "Vietnamese",
  "Micronesian",
  "Declined to Respond",
  "Other Hispanic",
  "US or Canadian Indian",
  "Puerto Rican",
  "Filipino",
  "Mexican",
  "Alaskan Native",
  "Cuban",
  "Other",
];

export function generateRandomId() {
  // Function to generate a random digit (0-9)
  function getRandomDigit() {
    return Math.floor(Math.random() * 10);
  }

  function getRandomDigitExceptNill() {
    return Math.floor(Math.random() * 9) + 1;
  }

  // Generate 5 random digits
  let randomDigits = `${getRandomDigitExceptNill()}`;
  for (let i = 0; i < 8; i++) {
    randomDigits += getRandomDigit();
  }

  return randomDigits;
}

export function getTrackingUrl(carrierName, trackingId) {
  const lowerName = carrierName.toLowerCase();

  if (lowerName.includes("usps") || lowerName.includes("postal")) {
    return `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${trackingId}`;
  }

  if (lowerName.includes("ups")) {
    return `https://www.ups.com/track?loc=en_US&tracknum=${trackingId}`;
  }

  if (lowerName.includes("fedex")) {
    return `https://www.fedex.com/fedextrack/?tracknumbers=${trackingId}`;
  }

  if (lowerName.includes("dhl")) {
    return `https://www.dhl.com/en/express/tracking.html?AWB=${trackingId}`;
  }

  if (lowerName.includes("amazon")) {
    return `https://www.amazon.com/progress-tracker/package/${trackingId}`;
  }

  if (lowerName.includes("laser") || lowerName.includes("lasership")) {
    return `https://www.lasership.com/track/${trackingId}`;
  }

  if (lowerName.includes("ontrac")) {
    return `https://www.ontrac.com/trackingres.asp?tracking_number=${trackingId}`;
  }

  if (lowerName.includes("canpar")) {
    return `https://www.canpar.com/en/track/TrackingAction.do?locale=en&trackRef=${trackingId}`;
  }

  if (lowerName.includes("purolator")) {
    return `https://www.purolator.com/en/shipping/tracker?pin=${trackingId}`;
  }

  // fallback
  return "https://delivery.careapps.net";
}

export const getTableSortOrder = (sort) => {
  if (!sort.includes("step:")) {
    return sort.split(":")[1];
  }

  return "";
};